import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPrinter2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"printer-2, print"} maskId="square-filled-radius-0-stroke-1-IconPrinter2"><path fillRule="evenodd" clipRule="evenodd" d="M17 21H7V8H17V21ZM10 16H12.5V15H10V16ZM10 12H14V11H10V12Z" fill="currentColor"/><path d="M22 12H18V7H6V12H2V3H22V12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPrinter2;
